/**
 * Предзагрузка тяжёлых сцен — по НАМЕРЕНИЮ, а не заранее.
 *
 * Порядок важности для посетителя: карта → этажерка → «Объём» → «Объём 3D».
 * Поэтому:
 *  - карта грузится сразу (без неё страница бесполезна);
 *  - «Объём» (лёгкий, ~20 КБ) подтягиваем в простое, когда карта уже показана;
 *  - «Объём 3D» (three.js, ~150 КБ gzip) — только когда человек навёл курсор
 *    или коснулся кнопки: платить за него всем посетителям карты нельзя.
 */
import { importChunk } from '../lazy-retry'

let started = false

/** Подтянуть 3D-сцену заранее (наведение на кнопку «Объём 3D»). */
export function prefetchVolume3d(): void {
  if (started) return
  started = true
  void Promise.all([
    importChunk(() => import('./model')),
    importChunk(() => import('./scene')),
  ]).catch(() => {
    started = false
  })
}

/** Запросить лёгкие сцены в простое браузера — после первого показа карты. */
export function prefetchOnIdle(run: () => void): void {
  const idle = (
    window as unknown as { requestIdleCallback?: (cb: () => void, o?: { timeout: number }) => void }
  ).requestIdleCallback
  if (typeof idle === 'function') idle(run, { timeout: 4000 })
  else setTimeout(run, 2500)
}
